import { useQuery } from '@tanstack/react-query'

import type { GetPublicInstallmentProviderResponse } from '../../types/payment-settings.js'

import { apiClient } from '../../lib/client.js'
import { paymentSettingsKeys } from './keys.js'

/**
 * Prestataire courant du paiement en plusieurs fois (endpoint public, sans auth).
 * staleTime élevé : le hook est monté par chaque flight card, une seule requête suffit.
 */
export const useGetPublicInstallmentProviderQuery = () => {
  return useQuery({
    queryFn: async () => {
      const response = await apiClient.client.get<GetPublicInstallmentProviderResponse>(
        '/payment-settings/public/installment-provider'
      )

      return response.data
    },
    queryKey: paymentSettingsKeys.publicProvider(),
    staleTime: 60_000,
  })
}
